import SeeMoreCard from "./SeeMoreCard";

export default function SectionTitle({ title, largeTitle, rightElement, seeMoreLink }) {
  return (
    <div className="flex justify-between items-center my-6">
      <div className="space-y-2">
        {largeTitle && (
          <h1 className="text-[34px] font-sora font-semibold leading-[23px] text-white">{largeTitle}</h1>
        )}
        {title && <h2 className={largeTitle ?
          "text-[22px] leading-[23px] font-sora text-white ml-1" :
          `text-[18px] leading-[23px] font-outfit font-semibold text-white`
        }>{title}</h2>}
      </div>

      {/* {showSeeMore && (
        <button className="text-gray-300 hover:text-white bg- text-sm">
          See more
        </button>
      )} */}
      {rightElement ? (
        <div>
          {rightElement}
        </div>
      ) :
         seeMoreLink ? (
          <div className="flex justify-end pt-1">
            <SeeMoreCard link={seeMoreLink} />
          </div>
        ) : null
      }
    </div>
  );
}
